import { FC } from "react";
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  UseFormRegisterReturn,
} from "react-hook-form";

type TextareaProps = {
  label: string;
  id: string;
  error?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
  register: UseFormRegisterReturn;
};

const Textarea: FC<TextareaProps> = ({ label, id, error, register }) => {
  return (
    <label
      htmlFor={id}
      className="grid p-3 bg-neutral-900 border border-neutral-300/10 rounded focus-within:border-neutral-300/20 transition-all duration-200"
    >
      <span className={`mono ${error ? "opacity-100" : "opacity-60"}`}>
        <span>
          {label}
          <span
            id={`${id}-error`}
            role="alert"
            className={`text-red-500 ${error ? "opacity-100" : "opacity-0 visibility-hidden"}`}
          >
            &nbsp;{error?.toString()}
          </span>
        </span>
      </span>
      <textarea
        id={id}
        rows={4}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        className="resize-none text-lg outline-none bg-transparent autofill:bg-yellow-200"
        {...register}
      />
    </label>
  );
};

export default Textarea;
